import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { coverFields, EstimateDto } from "./types.ts";
import { styles } from "../estimateStyle.tsx";
import { useEstimateApi } from "../../hooks/useEstimateApi.ts";

/**
 * Renders the byte-identical cover-fields grid that appears at the top
 * of `EstimateFormMun` and `EstimateFormComparison`.
 *
 * Iterates `coverFields` (from `./types.ts`) and emits one `<label>`
 * per descriptor with either a `<textarea>` (multiline=true, with
 * autoGrow) or `<input>` Controller-bound to `cover.<name>`.
 *
 * `EstimateForm` (jinyoung) does NOT render this block.
 *
 * Must be rendered inside an existing `FormProvider<EstimateDto>`.
 */
export default function CoverFieldsGrid() {
  const { control } = useFormContext<EstimateDto>();
  const { autoGrow } = useEstimateApi();

  return (
    <div style={styles.grid}>
      {coverFields.map(({ label, name, type, required, multiline }) => (
        <label
          key={name}
          style={{
            ...styles.label,
            ...(multiline ? styles.fullWidth : null),
          }}
        >
          {label}
          {required && <span style={styles.required}>*</span>}

          <Controller
            name={`cover.${name}` as const}
            control={control}
            rules={required ? { required: true } : undefined}
            render={({ field }) =>
              multiline ? (
                <textarea
                  {...field}
                  rows={5}
                  value={(field.value ?? "") as string}   // ✅ RHF 값으로 표시
                  style={styles.textarea}
                  onChange={(e) => {
                    field.onChange(e.target.value);       // ✅ value만 넣는 게 안전
                    autoGrow(e.target);
                  }}
                />
              ) : (
                <input
                  {...field}
                  type={type}
                  value={(field.value ?? "") as string}   // ✅ RHF 값으로 표시
                  style={styles.input}
                  onChange={(e) => {
                    field.onChange(e.target.value);       // ✅ value만
                  }}
                />
              )
            }
          />
        </label>
      ))}
    </div>
  );
}
